import React, { useContext, useEffect, useState } from "react";
import { Checkbox, makeStyles } from "@fluentui/react-components";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";
import { Truncate } from "../components-utils";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  column: Column;
};

const useStyles = makeStyles({
  checkboxWrapp: {
    display: "flex",
    alignItems: "center",
    padding: "5px 0",
    "&:first-child": {
      paddingTop: "0",
    },
    "&:last-child": {
      paddingBottom: "0",
    },
  },
  checkbox: {
    marginRight: "2px",
  },
});

export const TaxonomyFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const selectedValues = filter.value;
  const classes = useStyles();

  const renderLabel = filter.renderLabel;
  const { taxonomy, setFilter, t, id } = useContext(ColumnOptionsContext);
  const [maxSelectionReached, setMaxSelectionReached] = useState(false);

  const options = taxonomy[filter.taxonomyKey].filter((tax) => {
    if (filter.exclude) {
      return !filter.exclude.includes(tax.code);
    }
    return true;
  });

  const handleMaxSelectionReached = () => {
    if (
      filter?.maxOptionsSelect &&
      selectedValues.length >= filter?.maxOptionsSelect
    ) {
      setMaxSelectionReached(true);
    } else {
      maxSelectionReached && setMaxSelectionReached(false);
    }
  };
  useEffect(() => {
    handleMaxSelectionReached();
  }, [selectedValues]);

  return (
    <div>
      {options.map((tax) => {
        const isChecked = selectedValues.includes(tax.id);
        return (
          <div key={tax.id} className={classes.checkboxWrapp}>
            <Checkbox
              checked={isChecked}
              className={classes.checkbox}
              disabled={maxSelectionReached && !isChecked}
              id={
                id
                  ? `${id}-taxonomyFilter-${column.key}-${tax.code}`
                  : undefined
              }
              onChange={(_, data) => {
                let value;
                if (data.checked) {
                  if (maxSelectionReached && !isChecked) return;
                  value = selectedValues.concat([tax.id]);
                } else {
                  value = selectedValues.filter((id) => id !== tax.id);
                }

                setFilter(column.key, {
                  ...filter,
                  value,
                });
              }}
            />
            {renderLabel ? (
              renderLabel({ taxonomy: tax, t })
            ) : (
              <Truncate>{t(tax.code)}</Truncate>
            )}
          </div>
        );
      })}
    </div>
  );
};
